import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import signup_bg_dark from "../LandingPage/logo/signup_bg.svg";
import googleStoreLogo from "./googleStoreLogo.png"
import appleStoreLogo from "./appleStoreLogo.png"
import { EventTypes, trackEvent } from "../../Utils/Analytics";
import { ENV } from "../../path";
import { getPlaystoreLinks } from "../../Utils/attribution"

function DownloadAppPage() {
  const { user } = useSelector((state) => state.AuthReducer);
  const history = useHistory();
  
  const { intentUrl, playStoreLink } = getPlaystoreLinks();
  const ua = window.navigator.userAgent || navigator.vendor || window.opera;
  const isAndroid = ua.includes("Android");
  const playstoreIntentUrl = isAndroid? intentUrl: playStoreLink;

  useEffect(() => {
    if (user?.isMarketingAdmin) {
      history.push("/marketingadmin");
    }else if(user?.isAdmin){
      history.push("/admin");
    }
  }, []);

  const linkClickHandler = async () => {
    if(ENV === "prod"){
      trackEvent(EventTypes.DOWNLOAD_CLICK, { location: "welcome_page" });
    }
  }

  return (
<div className="flex flex-col-reverse md:flex-row min-h-screen w-full gap-6 p-6 bg-slate-100 overflow-y-auto">
  {/* Text Section */}
  <div className="w-full md:w-1/2 flex flex-col p-4 gap-2 justify-center">
    
    <h1 className="text-4xl md:text-3xl font-bold  mb-2 font-gilroy-bold">
      Welcome to Feedants
    </h1>

    <p className="mb-2 font-gilroy-semibold">
    your all-in-one stage for unleashing artistic and athletic talent! 🎉 <br/>
      Our website is taking a quick break, but the action never stops. Download the Feedants app now to:
    </p>

    <ul className="list-disc list-inside space-y-3 mb-4 font-gilroy-semibold">
      <li>
        <strong>Showcase Your Skills:</strong> Join live contests—online or in person—and build your own
        portfolio, just like LinkedIn for artists.
      </li>
      <li>
        <strong>Earn and Grow:</strong> Win cash prizes, gain recognition, and connect with fellow creators in a
        fully interactive environment.
      </li>
      <li>
        <strong>Stay Engaged:</strong> Participate in 50+ competitions, celebrate 1,000+ winners, and tap into
        opportunities you won’t find anywhere else.
      </li>
    </ul>

    <p className="text-lg font-gilroy-semibold font-semibold ">Ready to turn your passion into performance?</p>
    <p className="mb-6 font-gilroy-semibold text-lg">👇 Tap below to get the app and step onto the Feedants stage! 👇</p>


    <div className=" flex flex-col md:flex-row gap-2 w-fit">
      <a
      target="_blank"
      rel="noopener noreferrer"
      href={playstoreIntentUrl} 
      className=" items-center bg-black rounded-xl px-10  py-2 flex gap-6 mt-4"
      onClick={linkClickHandler}
      >
        <img
          src={googleStoreLogo}
          alt="vector"
          className=" w-12 h-12"
        />
        <div className="flex flex-col items-center font-gilroy-medium text-white">
          <p className="">Get It On </p>
          <h2 className=" text-xl font-medium"> Google Play</h2>
        </div>
      </a>

      <a
      target="_blank"
      rel="noopener noreferrer"
      onClick={linkClickHandler}
      href="https://apps.apple.com/in/app/feedants/id6477408585" className=" items-center bg-black rounded-xl px-10  py-2 flex gap-6 mt-4">
        <img
          src={appleStoreLogo}
          alt="vector"
          className=" w-12 h-12"
        />
        <div className="flex flex-col items-center font-gilroy-regular text-white">
          <p className="">Available on</p>
          <h2 className=" text-xl font-medium">Apple Store</h2>
        </div>
      </a>
    </div>


  </div>

  {/* Image Section */}
  <div className="w-full md:w-1/2 flex justify-center items-center">
    <img
      src={signup_bg_dark}
      alt="vector"
      className="scale-100 md:scale-125 max-h-[60vh] object-contain"
    />
  </div>
</div>

  )
}

export default DownloadAppPage;
